import { render } from "./InvitationSection.vue?vue&type=template&id=13b8b95c&scoped=true"
import script from "./InvitationSection.vue?vue&type=script&lang=js"
export * from "./InvitationSection.vue?vue&type=script&lang=js"

import "./InvitationSection.vue?vue&type=style&index=0&id=13b8b95c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b8b95c"]])

export default __exports__